<template>
  <div>
    <s-search-staff
      show-support-staff
      show-group
      :select.sync="euid"
      :staff.sync="nextStaffObj"
      :label="$t('TaskList.DefaultNextStaff')"
      class="mb-4"
      clearable
    />
    <v-btn
      color="primary"
      class="mr-2"
      @click="save"
    >
      {{ $t('PublicServant.Action.Save') }}
    </v-btn>
  </div>
</template>

<script>

// import store from '@/store'
import { mapGetters } from 'vuex'

import { globalModule, staffModule } from '@/store/moduleName'
// import staffSettingVuex from '@/store/modules/hr/staffSetting'
import SSearchStaff from '@/components/SSearchStaff'
import staffSettingApi from '@/api/hr/staffSetting'
// import { SEARCH_STAFF_RECORD_TYPE } from '@/constant/constant'
// import { get } from '@/utils/objectUtil'

// if (!store.state[staffSettingModule]) store.registerModule(staffSettingModule, staffSettingVuex)

export default {
  components: {
    SSearchStaff
  },
  data: function () {
    return {
      euid: null,
      nextStaffObj: null
    }
  },
  computed: {
    ...mapGetters(staffModule, {
      defaultNextStaff: 'getDefaultNextStaff'
    })
  },
  created () {
    this.$store.dispatch(staffModule + '/loadDefaultNextStaff').then(() => {
      this.euid = this.defaultNextStaff
    })
    // this.$store.dispatch(staffSettingModule + '/getDefaultNextStaff').then(() => {
    //   this.euid = this.defaultNextStaff
    // })
  },
  methods: {
    save: function () {
      if (this.euid) {
        let isStaff = true
        // let recordType = get(this.nextStaffObj, 'recordType')
        // if (recordType && (recordType === SEARCH_STAFF_RECORD_TYPE.GROUP)) {
        if (this.euid && !this.euid.startsWith('E')) {
          isStaff = false
        }
        staffSettingApi.updateDefaultNextStaff(isStaff, this.euid, cb => {
          if (cb.status === 201 || cb.status === 200) {
            this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Training.Msg.SubmitSuccess'))
            this.$store.dispatch(staffModule + '/refreshDefaultNextStaff')
          }
        })
      } else {
        staffSettingApi.deleteDefaultNextStaff(cb => {
          if (cb.status === 201 || cb.status === 200) {
            this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Training.Msg.SubmitSuccess'))
            this.$store.dispatch(staffModule + '/refreshDefaultNextStaff')
          }
        })
      }
    }
  }
}
</script>
